module.exports = __webpack_public_path__ + "static/media/git.b1ae5bf0.svg";